import React from 'react';
import AsyncLoading from '@components/AsyncLoading/AsyncLoading';
import OnlineExamConfig from './routes/OnlineExamConfig';
import ViewExamSubmission from './routes/ViewExamSubmission';

const ExamSetupDetailLazy = React.lazy(
	() => import(/* webpackChunkName : 'ExamSetupDetail' */ './components')
);

export default (store) => {
	return [
		{
			path: 'examgrading-setup/exam-setup/:campusId/:examId',
			element: (
				<AsyncLoading
					component={
						<ExamSetupDetailLazy
							permission="CanViewExamGradingSetup"
							featureFlag="FeatureFlag:OnlineExams"
						/>
					}
				/>
			),
		},
		OnlineExamConfig(store),
		...ViewExamSubmission(store),
	];
};
